import React from "react";


const FAQ = () => {
    return(
        <h1>FAQ</h1>
    )
}

export default FAQ